import { Injectable } from "@angular/core";
import { cloneDeep } from "lodash";
import Feature from "ol/Feature";
import LineString from "ol/geom/LineString";
import MultiLineString from "ol/geom/MultiLineString";
import MultiPolygon from "ol/geom/MultiPolygon";
import Point from "ol/geom/Point";
import Polygon from "ol/geom/Polygon";
import { Fill, Stroke, Style,Text } from 'ol/style';
import { Layer } from "../menu/view-menu/layer";
import { UserLayer } from "../models/UserSettings";
import { ConfigurationService } from "./configuration.service";
import { UserSettingsService } from "./userSettings.service";
import { UtilsService } from "./utils.service";

@Injectable({
  providedIn: 'root'
})
export class UserAddedLayersService{

  constructor(public userSettingsService: UserSettingsService,
    public configurationService: ConfigurationService,
    public utilsService: UtilsService

    ){

    }
    public applyLayerChange(changedUserLayer: UserLayer,layer:Layer, staticLayer: boolean){
      let features: Feature[] = layer.olLayer.getSource().getFeatures();
      let oldUserLayer:UserLayer;
      if(staticLayer){
       let index = this.userSettingsService.userSettings.staticGeoJsonLayers
        .findIndex((userLayer:UserLayer) =>
        userLayer.id == changedUserLayer.id
        );
        this.userSettingsService.userSettings.staticGeoJsonLayers.splice(index,1);
        this.userSettingsService.userSettings.staticGeoJsonLayers.push(changedUserLayer);
      }
      else{
        let index= this.userSettingsService.userSettings.userLayers
        .findIndex((userLayer:UserLayer) =>
        userLayer.id == changedUserLayer.id
        );
        this.userSettingsService.userSettings.userLayers.splice(index,1);
        this.userSettingsService.userSettings.userLayers.push(changedUserLayer);

      }
      //oldUserLayer = cloneDeep(changedUserLayer);
      this.userSettingsService.updateSettings();
      this.changeLayerStyle(features,changedUserLayer);
    }
    public changeLayerStyle(features:Feature[], userLayer:UserLayer){
      features.forEach((feature:Feature) =>
      {
        let style: Style;
        if(feature.get('geometry') instanceof LineString || feature.get('geometry') instanceof MultiLineString){
          style = new Style({
            stroke: userLayer.lineChecked? new Stroke({
              color: this.utilsService.hexToRgb2(userLayer.strokeColor,userLayer.lineOpacity),
              width : userLayer.lineWidth
            }): null
          })
        }
        else if(feature.get('geometry') instanceof Polygon || feature.get('geometry') instanceof MultiPolygon){
          style = new Style({
            stroke: userLayer.lineChecked? new Stroke({
              color: this.utilsService.hexToRgb2(userLayer.strokeColor,userLayer.lineOpacity),
              width : userLayer.lineWidth
            }) : null,
            fill: userLayer.fillChecked? new Fill({color: this.utilsService.hexToRgb2(userLayer.fillColor,userLayer.fillOpacity)}) : null
          })
        }
        else if(feature.get('geometry') instanceof Point){
          style = this.utilsService.getStyleOfShape(userLayer.shape,
            userLayer.lineChecked? userLayer.strokeColor: null,userLayer.lineWidth,
            userLayer.fillChecked? userLayer.fillColor: null,userLayer.radius);
        }
        if(userLayer.propertyDisplayed != null && feature.get(userLayer.propertyDisplayed) != "" && userLayer.labelChecked){
          style.setText(new Text({text: String(feature.get(userLayer.propertyDisplayed)), scale: 2}));
          feature.setStyle(cloneDeep(style))
        }
        else{
          feature.setStyle(style);
        }

      })
    }






}
